<!-- 桌位排行 -->
<template>
    <div id="home">
    	<van-nav-bar
		  	:title="$t('TableRank.title')"
			left-arrow
			fixed
			z-index=9
		  	@click-left="$router.go(-1)">
		</van-nav-bar> 
		<div class="contentWrapper">
			<van-cell-group>
				<span class="text">{{$t('TableRank.text1')}}</span>
				<van-field
					class="inputAr"
					readonly  	
					right-icon="arrow" 	  	
					@click="showStartTimePicker = true" 	
					:value='tables.startTime'
				/> 
				<!-- 弹框 -->
				<van-popup v-model="showStartTimePicker" position="bottom">
					<van-datetime-picker
						v-model="currentDate"
						type="date"
						:max-date="maxDate"
						:confirm-button-text="$t('vantText.confirm')"
						:cancel-button-text="$t('vantText.cancel')"
						@cancel="showStartTimePicker = false"
						@change="changeStartTime()"
						@confirm="onStartChangeConfirm"
					/>
				</van-popup>
				<span class="text">{{$t('TableRank.text')}}</span>
				<van-field
					class="inputAr"
					readonly
					right-icon="arrow" 		
					@click="showEndTimePicker = true"
					:value='tables.endTime'
				/>  
				<!-- 弹框 -->
				<van-popup v-model="showEndTimePicker" position="bottom">
					<van-datetime-picker
						v-model="currentEndDate"
						type="date"
						:min-date="minDate"
						:confirm-button-text="$t('vantText.confirm')"
						:cancel-button-text="$t('vantText.cancel')"
						@cancel="showEndTimePicker = false"
						@change="changeEndTime()"
						@confirm="onChangeConfirm"
					/>
				</van-popup>
			</van-cell-group>
			<div class="divideLine"></div>
			<van-tabs v-model="active" @click=onTableRank>
				<van-tab :title="$t('TableRank.amountOfMoney')">
					<!-- 表头 -->
					<van-cell>
						<van-row class='title'>
							<van-col span="3">{{$t('TableRank.rank')}}</van-col>
							<van-col span="10">{{$t('TableRank.num')}}</van-col>
							<van-col span="6">{{$t('TableRank.price')}}({{currency}})</van-col>
							<van-col span="5">{{$t('TableRank.amount')}}</van-col>	
						</van-row>
					</van-cell>
					<van-cell v-for="(item,index) in tablesList" :key='index' >
						<van-row>
							<van-col span="3">{{index+1}}</van-col>
							<van-col span="10">{{item.name}}</van-col>
							<van-col span="6">{{item.price}}</van-col>
							<van-col span="5">{{item.sitter}}{{$t('TableRank.people')}}</van-col>	
						</van-row>
					</van-cell>
				</van-tab>
				
				<van-tab :title="$t('TableRank.peoopleNum')" >
					<!-- 表头 -->
					<van-cell>
						<van-row class='title'>
							<van-col span="3">{{$t('TableRank.rank')}}</van-col>
							<van-col span="10">{{$t('TableRank.num')}}</van-col>
							<van-col span="6">{{$t('TableRank.price')}}({{currency}})</van-col>
							<van-col span="5">{{$t('TableRank.amount')}}</van-col>	
						</van-row>
					</van-cell>
					<van-cell v-for="(item,index) in tablesList" :key='index'>
						<van-row>
							<van-col span="3">{{index+1}}</van-col>
							<van-col span="10">{{item.name}}</van-col>
							<van-col span="6">{{item.price}}</van-col>
							<van-col span="5">{{item.sitter}}{{$t('TableRank.people')}}</van-col>
						</van-row>
					</van-cell>
				</van-tab>
			</van-tabs>
		</div>
    </div>
</template>
<script>
  	export default {
  		data(){
  			return{
  				active: 2,
  				tablesList:[],
  				tables:{
  					startTime:this.formatDateYMD1(new Date()),
  					endTime:this.formatDateYMD(new Date())
  				},
  				maxDate:new Date(),
  				minDate:new Date(),
  				currentDate:new Date(),
  				currentEndDate:new Date(),
  				showStartTimePicker:false,
  				showEndTimePicker:false,
  				price:'price',   //金额
				sitter:'sitter', //人数
				currency:''
  			}
  		},
  		mounted(){
  			// this.tables.startTime=this.formatDateYMD(new Date());
  			// this.tables.endTime=this.formatDateYMD(new Date());
			  this.getTableRank(this.price);
			  this.getCurrency()
  		},
  		methods:{
  			getTableRank(rankType){
				this.$axios({
	                method: 'PATCH',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/placeRank',
	                data:{
	                	startday:this.tables.startTime,
	                	endday:this.tables.endTime,
	                	type:rankType
	                }
	            }).then(res => {
	            	if(res.data.status==200){
	                	this.tablesList=res.data.data;
	            	}else{
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	
	            });
	    	},
  			onChangeConfirm(){
				this.tables.endTime=this.formatDateYMD(this.currentEndDate);
	    		this.showEndTimePicker = false;
	    		if(this.active == 0){
	    			this.getTableRank(this.price);
	    		}else{
	    			this.getTableRank(this.sitter);
	    		}
	    	},
	    	onStartChangeConfirm(){
	    		this.tables.startTime=this.formatDateYMD(this.currentDate);
	    		this.showStartTimePicker = false;
	    		if(this.active == 0){
	    			this.getTableRank(this.price);
	    		}else{
	    			this.getTableRank(this.sitter);
	    		}
	    	},
	    	//开始时间显示前一个月
	    	formatDateYMD1(value){
			    if (!value){ 
			        return '';
			    }else{
			        var date = new Date(value);
			        var Y = date.getFullYear();
			        var M = (date.getMonth()+1);
			        var D = date.getDate();

			        //获取前一个月的日期
			        var Y2=Y;
			        var M2=parseInt(M) - 1;
			        //如果月为0则显示去年最后一个月12月
			        if(M2==0){
			        	Y2 = parseInt(Y2) - 1;
        				M2 = 12;
			        }
			        var D2=D;
			        var DS2=new Date(Y2, M2, 0); 
			        DS2=DS2.getDate(); 
			        if(D2>DS2){
			        	D2=DS2
			        }
			        if(M2<10){
			        	M2=M2;
			        }
			        var t2=Y2 + '/' + M2 + '/' + D2;
			        return t2;
			    }
			},
	    	formatDateYMD(value){
			    if (!value){ 
			        return '';
			    }else{
			        var date = new Date(value);
			        var Y = date.getFullYear()+'/';
			        var M = (date.getMonth()+1)+ '/';
			        var D = date.getDate();
			        return Y+M+D;
			    }
			},
			changeStartTime(){
				this.tables.startTime=this.formatDateYMD(this.currentDate);
				this.minDate=this.currentDate;
			},
			changeEndTime(){
				this.tables.endTime=this.formatDateYMD(this.currentEndDate);
				this.maxDate=this.currentEndDate;
			},
			onTableRank(name,title){
				if(title==this.$t('TableRank.amountOfMoney')){
					this.getTableRank(this.price);
				}else if(title == this.$t('TableRank.peoopleNum')){
					this.getTableRank(this.sitter);
				}		
			},
			// 获取店铺设置的货币
			getCurrency(){
				this.$axios({
					method: 'get',
					headers: {
						"Authorization": 'Bearer '+sessionStorage.token,
					},
					url: this.$build+'/api/store/'+sessionStorage.actShopId+'/currency',
				}).then(res => {
					console.log(res);
					if(res.data.status==200){
						this.currency = res.data.data.unit
					}else{
						for (var item in res.data.error) {
							this.$toast({
								type:'fail',
								message:res.data.error[item],
							});
						}
					}
				}).catch(err => {
					this.$toast({
						type:'fail',
						message:this.$t('EditDish.message'),
					});
				});
			},
  		}
  	}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-cell{
		line-height: 24px;
	}
	/deep/ .van-tabs__line{
		background-color: #fd3f3f;
	}
	/deep/ .van-picker__cancel,/deep/ .van-picker__confirm{
		color: #2f75f7
	}
	/deep/ .van-field__right-icon{
		margin-right:-10px;
		padding:0 5px;
	}
	.contentWrapper{
		/* padding-top: 46px; */
	}
	/*分割线*/
	.divideLine{
		height: 5px;
		background: #F3F5F7;
	}
	.van-cell-group{
		padding: 15px;
		display: flex;
		justify-content: space-between;
	}
	.inputAr{
		width: 40%;
		/*height: 35px;*/
		line-height: 15px;
		border: 2px solid #000;
		border-radius: 50px;
		font-size: 14px;
	}
	/* 至 */
	.text{
		line-height: 35px
	}
	.title{
		font-size: 14px;
		color: #444;
	}
</style>


// WEBPACK FOOTER //
// src/Report/TableRank.vue